import {
  FETCH_ADMIN_APPROVED_COURSES_REQUEST,
  FETCH_ADMIN_APPROVED_COURSES_SUCCESS,
  FETCH_ADMIN_APPROVED_COURSES_FAILURE,
  CLEAR_ADMIN_APPROVED_COURSES,
} from "../Actions/adminApprovedCoursesAction";

const initialState = {
  loading: false,
  approvedCourses: [],
  error: null,
};

const adminApprovedCoursesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ADMIN_APPROVED_COURSES_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_ADMIN_APPROVED_COURSES_SUCCESS:
      return { ...state, loading: false, approvedCourses: action.payload };
    case FETCH_ADMIN_APPROVED_COURSES_FAILURE:
      return {
        ...state,
        loading: false,
        approvedCourses: [],
        error: action.payload,
      };
    case CLEAR_ADMIN_APPROVED_COURSES:
      return {
        approvedCourses: [],
        loading: false,
        error: null,
      };
    default:
      return state;
  }
};

export default adminApprovedCoursesReducer;
